import { memo } from "react";
import { colors, css, fonts } from "../Styles";
import { icons } from "../Styles/images"
import { TerminalInfo } from "../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";

interface MotorSpecs_Props{
  terminals: TerminalInfo[]
}

export default function MotorSpecs({terminals}:MotorSpecs_Props) {
  return (
    <div style={{ position: "relative", width: "350px", height: "170px", display: "block" }}>
      
      <div style={{ position: "absolute", top: "0px", left: "0px", zIndex: "0", width: "350px", height: "170px", overflow: "hidden", borderRadius: "10px", backgroundColor: colors.greyLightSecondary }} />
      
      <div style={{position: "absolute", width: "350px", height: "170px", overflow: "hidden", top: "0px", left: "0px", zIndex: "1" }}>
        <img src={icons.motorLF} alt="gokkelok" style={{position: "absolute", width: "130%", top: "-110px", opacity: "0.05"}}/>
      </div>

      <div style={{ position: "absolute", top: "0px", left: "0px", zIndex: "2", width: "350px", height: "170px", border: "5px solid " + colors.transparent, backgroundColor: colors.transparent, borderRadius: "10px", padding: "10px", boxSizing: "border-box", overflowX: "hidden", overflowY: "auto", scrollbarColor: colors.greyTertiary + colors.transparent, scrollbarWidth: "thin" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px"}}>
          {terminals?.map((terminal, index) => { return ( <MotorComponent terminal={terminal} /> ) })}
        </div>  
      </div>

    </div>
  )
}

const TerminalType: Record<number, {label: string, src: string}> = {
  50: {label: "Default Motor", src: icons.motorLF},
  80: {label: "LocationFeeder", src: icons.feederLF},
  81: {label: "LocationFeeder", src: icons.feederLF},
  4: {label: "Activator", src: icons.activatorLF}
};

const MotorComponent = memo(({ terminal }: { terminal: TerminalInfo }) => {
  const formatLabel = (label: string) => label.replace(/([a-z])([A-Z])/g, "$1 $2");
  
  const specs: Record<string, {value: string | number | undefined, unit: string}> = {
    PowerConsumption: { value: terminal.val1_max, unit: "m/A" },
    CalibrationValue: { value: terminal.val2_min, unit: "g" },
    RotationTime: { value: terminal.time_act, unit: "sec" },
    StatusMode: { value: terminal.programmed, unit: "" },
  };

  if (terminal.programmed) {
    var arr = terminal.programmed.toString(2).split("").reverse();
    if (arr.length >= 1 && arr[0] === "1") {
      specs.StatusMode = {value:"Disabled", unit: ""};
    }
    else if (arr.length >= 5 && arr[4] === "1") {
      specs.StatusMode = {value:"Calibration", unit: ""};
    }
    else if (arr.length >= 3 && arr[2] === "1") {
      specs.StatusMode = {value:"Feeding on FeedingTimes", unit: ""};
    }
    else {
      specs.StatusMode = {value:"Motor passive", unit: ""};
    }
  }

  return (
    <div style={{display: "grid", gridTemplateColumns: "70px 2px 1fr", gridTemplateRows: "1fr", gap: "10px"}}>
      <div style={{ gridArea: "1/1/2/2" }}>
        <img src={TerminalType[terminal.fk_terminal_types ?? 50].src} alt="duttelut" style={{width: "100%"}}/>
      </div>

      <div style={{ gridArea: "1/2/2/3", borderLeft: "2px solid " + colors.greyTertiary }} />
      
      <div style={{ gridArea: "1/3/2/4", display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "20px 1fr"}}>
        <div style={{gridArea: "1/1/2/2", ...fonts.fontSize3, ...fonts.header, color: colors.greyDarkPrimary}}>
          {TerminalType[terminal.fk_terminal_types ?? 50].label}
        </div>
        <div style={{ gridArea: "2/1/3/2" }}>
          {Object.entries(specs).map(([label, {value, unit}]) => (
            <div style={{display: "grid", gridTemplateColumns: "150px 1fr", gridTemplateRows: "1fr"}}>
              <div style={{ gridArea: "1/1/2/2", ...fonts.paragraph, ...fonts.fontWeight2, ...fonts.fontSize4, color: colors.greyDarkPrimary }}>{formatLabel(label)}</div>
              <div style={{gridArea: "1/2/2/3", ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{`${value} ${unit}`}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})